import { initMobileMenu } from "./initMobileMenu";

export const mobileMenu = {
  initMobileMenu
};
